function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVersions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.467.979a.1.1 0 0 0-.055.017L-.128 6.09a.122.122 0 0 0 0 .207L1.634 7.35-.13 8.4a.122.122 0 0 0 0 .207l1.756 1.055-1.756 1.047a.122.122 0 0 0 0 .207l8.541 5.094a.12.12 0 0 0 .125 0l8.541-5.094a.122.122 0 0 0 0-.207l-1.762-1.05 1.762-1.052a.122.122 0 0 0 0-.207l-1.764-1.05 1.764-1.053a.122.122 0 0 0 0-.207L8.538.996A.12.12 0 0 0 8.466.98m.008.86 7.298 4.354-1.26.752v-.002q-3.02 1.8-6.038 3.604L2.939 7.244l-1.763-1.05ZM2.373 7.79l6.04 3.602a.12.12 0 0 0 .124 0l6.04-3.602 1.196.715-1.761 1.05-5.537 3.301-5.537-3.3-1.762-1.051Zm-.002 2.31 6.041 3.602a.12.12 0 0 0 .125 0l6.041-3.601 1.195.713-7.298 4.353-7.3-4.353Z",
    style: {
      strokeWidth: 0.54868084
    },
    transform: "matrix(.97648 0 0 .97648 .25 .122)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVersions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/versions.svg";